<template>
  <v-dialog v-model="showDialog" max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>Translation Files</span>
        <v-btn icon @click.stop="showDialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        This translation includes more than one file. They can be downloaded from the menu below.
        <v-simple-table>
          <thead>
            <tr>
              <th colspan="2">
                Name
              </th>
            </tr>
          </thead>
          <tbody v-if="activity.files">
            <template v-for="file in activity.files">
              <tr :key="`file-${file.id}-header`">
                <td class="fs-exclude w-100">
                  {{ file.fileName }}
                </td>
                <td>
                  <v-btn icon @click="downloadActivityFile(file.id)">
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    activity: { type: Object, required: true },
    value: { type: Boolean, required: true },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        return this.$emit('input', val)
      }
    }
  },
  methods: {
    downloadActivityFile(fileId) {
      this.$emit('download', fileId)
    }
  }
}
</script>
